/*
 * A typescript & react boilerplate with api call example
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { StorageKey } from '@nu-art/thunderstorm-frontend/index';
import { _values, BadImplementationException, Module } from '@nu-art/ts-common';
export class ModuleFE_Workspace_Class extends Module {
    workspacesToUpsert = {};
    upsertRunnable;
    getWorkspaceConfigByKey = (key) => {
        const workspace = this.getWorkspaceByKey(key);
        const config = workspace?.config || this.config.defaultConfigs[key];
        if (!config)
            throw new BadImplementationException(`Could not find config for key ${key}`);
        return config;
    };
    getWorkspaceByKey = (key) => {
        return this.getStorageKeyForWorkspace(key).get();
    };
    getStorageKeyForWorkspace = (key) => new StorageKey(`workspace_key__${key}`).sameInstance();
    setWorkspaceByKey = async (key, config) => {
        this.workspacesToUpsert[key] = { key: key, config: config };
        clearTimeout(this.upsertRunnable);
        this.upsertRunnable = setTimeout(async () => {
            const values = _values(this.workspacesToUpsert);
            values.forEach(workspace => {
                this.logDebug('SET WORKSPACE KEY', `KEY: ${workspace.key}`);
                this.getStorageKeyForWorkspace(workspace.key).set(workspace);
            });
            this.workspacesToUpsert = {};
        }, 500);
    };
    deleteWorkspaceByKey = async (key) => {
        this.getStorageKeyForWorkspace(key).delete();
    };
}
export const ModuleFE_Workspace = new ModuleFE_Workspace_Class();
//# sourceMappingURL=ModuleFE_Workspace.js.map